import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDoubleRight } from '@fortawesome/pro-solid-svg-icons';
import pluralize from 'pluralize';

import Banner from 'components/banner';

export function CopyRecordsConfirmation({ sourceDatabase, targetDatabase, selectedPropertyIds }) {
  const count = selectedPropertyIds.length;

  const infoMessage = () => {
    return (
      <React.Fragment>
        <h3 className="bold mb-4">Copy Properties</h3>
        <div className="d-flex mb-2">
          <div className="align-self-center">
            <FontAwesomeIcon className="double-chevron text-primary mr-3" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div className='"align-self-center'>
            <strong>Property (Copied to Selected Database; Remains from Current Database)</strong>
            <br />
            Property Information, Location Information, Building, Land, Multifamily Information and Media
          </div>
        </div>
        <div className="d-flex mb-2">
          <div className="align-self-center">
            <FontAwesomeIcon className="double-chevron text-primary mr-3" icon={faChevronDoubleRight} size="sm" />
          </div>
          <div className="align-self-center">
            <strong>Related Data (Copied to Selected Database; Remains from Current Database)</strong>
            <br />
            Activities and Tasks, Groups, Tags, Related Contacts, Sale and Lease Comps and Listings
          </div>
        </div>
      </React.Fragment>
    );
  };

  const firstDescription = () => {
    return (
      <div className="align-self-center px-4">
        Once copied to {targetDatabase.name}, these properties&nbsp;
        <strong>will be exist in both</strong> {sourceDatabase.name} and {targetDatabase.name}.
      </div>
    );
  };  

  const secondDescription = () => {
    return (
      <div className="align-self-center px-4">
        <strong>All related data will be copied</strong> to my {targetDatabase.name} and therefore&nbsp;
        <strong>exist in both</strong> {sourceDatabase.name} and {targetDatabase.name}
      </div>
    );
  };

  return (
    <React.Fragment>
      <p>{`${count} ${pluralize('property', count)} will be copied to ${targetDatabase.name}.`}</p>
      <Banner
        content={firstDescription()}
        infoMessage={infoMessage()}
      />
      <Banner
        content={secondDescription()}
        infoMessage={infoMessage()}
      />
      <p>You will receive an email when the copy is complete.</p>
    </React.Fragment>
  );
}

CopyRecordsConfirmation.propTypes = {
  selectedPropertyIds: PropTypes.array.isRequired,
  sourceDatabase: PropTypes.object.isRequired,
  targetDatabase: PropTypes.object.isRequired
};


const mapStateToProps = state => ({
  selectedPropertyIds: state.selectList.selectedPropertyIds,
});

export default connect(mapStateToProps, null)(CopyRecordsConfirmation);
